<div class="container" aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    <h1 mat-dialog-title class="export-title font-lang-10">Export to CSV</h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close class="export-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form [formGroup]="formGroup" >
      <p class="text-bold font-lang-5">Customize the CSV file by selecting the data columns to export:</p>
      <div>
        <ul class="checkbox-list">
          <li>
            <mat-checkbox class="bigger-checkbox " formControlName="calendarYearCheck" aria-label="calendarYear"
                         >
              Calendar Year
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Calendar Year</p>
              <mat-form-field appearance="outline" class="select-field" style="max-width: 180px;">
                <mat-label>Calendar Year</mat-label>
                <mat-select [(value)]="filters.calendarYear" (selectionChange)="onCalendarYearChange($event.value)">
                  <mat-option [value]="null">--</mat-option>
                  @for (year of data.calendarYears; track year) {
                    <mat-option [value]="year">{{ year }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox " formControlName="fiscalYearCheck" aria-label="fiscalYearCheck"
            >
              Fiscal Year
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Fiscal Year</p>
              <mat-form-field appearance="outline" class="select-field" style="max-width: 180px;">
                <mat-label>Fiscal Year</mat-label>
                <mat-select [(value)]="filters.fiscalYear" (selectionChange)="onFiscalYearChange($event.value)">
                  <mat-option [value]="null">--</mat-option>
                  @for (year of data.fiscalYears; track year) {
                    <mat-option [value]="year">{{ year }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox " formControlName="regionCheck" aria-label="regionCheck"
            >
              Region
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Region</p>
              <mat-form-field appearance="outline" class="select-field" style="max-width: 180px;">
                <mat-label>Region</mat-label>
                <mat-select [(value)]="filters.region" (selectionChange)="onRegionChange($event.value)">
                  <mat-option [value]="null">--</mat-option>
                  @for (region of data.regions; track region) {
                    <mat-option [value]="region">{{ region }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox " formControlName="forestNameCheck" aria-label="forestNameCheck"
            >
              Forest
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Forest</p>
              <mat-form-field appearance="outline" class="select-field" style="max-width: 180px;">
                <mat-label>Forest</mat-label>
                <mat-select [(value)]="filters.forestName" (selectionChange)="onForestChange($event.value)">
                  <mat-option [value]="null">--</mat-option>
                  @for (forest of data.forestNames; track forest) {
                    <mat-option [value]="forest">{{ forest }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
          <li>
            <mat-checkbox class="bigger-checkbox " formControlName="treatmentOptionIdCheck" aria-label="treatmentOptionIdCheck"
            >
              Treatment
            </mat-checkbox>
          </li>
          <li>
            <div class="side-line">
              <p class="text-bold font-lang-5 select-label">Treatment</p>
              <mat-form-field appearance="outline" class="select-field" style="max-width: 180px;">
                <mat-label>Treatment</mat-label>
                <mat-select [(value)]="filters.treatmentOptionId" (selectionChange)="onTreatmentChange($event.value)">
                  <mat-option [value]="null">--</mat-option>
                  @for (t of data.treatmentOptions; track t) {
                    <mat-option [value]="t.id">{{ t.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </li>
        </ul>
      </div>
    </form>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row-always">
      <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      <button class="usa-button" (click)="exportToCsv()" >
        Export
      </button>
    </div>
  </div>
</div>
